import { useState, useEffect } from "react";
import { ContextApi } from "./ContextApi";
import { useCookies } from "react-cookie";
import { verifyApi } from "./api/verifyApi";
import { signout } from "../components/utils/extra/signout";

const Store = ({ children }) => {
  const [cookies, setCookie, removeCookies] = useCookies();
  const [auth, setAuth] = useState({
    isAuthenticated: null,
    role: "",
  });
  const [lang, setLang] = useState("AR");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const token = cookies.__t0ken_amar_management;
    const verify = async () => {
      await verifyApi(setAuth, lang, token, removeCookies);
    };

    if (token) {
      verify();
    } else {
      signout(setAuth, removeCookies);
    }
  }, []);

  return (
    <ContextApi.Provider
      value={{
        authentication: [auth, setAuth],
        language: [lang, setLang],
        loading: [loader, setLoader],
      }}
    >
      {children}
    </ContextApi.Provider>
  );
};

export default Store;
